import React, { useEffect, useState } from 'react';
import { Container, Header, Segment, Button, Modal, Pagination } from 'semantic-ui-react';
import { connect } from 'react-redux'
import moment from 'moment'
import cogoToast from 'cogo-toast';

import TitleBar from '../titleBar/titleBar';
import AgGridTable from '../agGridComponent/agGridTable';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';
import EditModal from '../modals/editModal';
import BillApprovalModal from './billApprovalModal';

import BillActionButton from './billActionButton';
import PaymentActionButton from './paymentActionButton';
import IntegratedReferenceNumber from './integratedReferenceNumber';
import { DATE_FORMATS, EnableIntegratedReferenceNo, EnableIntegratedRefErrorContent, transworldCustomer } from "../../config/const";
import { headers } from './bill.constants';

//Redux Actions
import { deleteBill, getBills, getFilteredBills, getPenalties, undoApproveBill, getBillPagination } from '../../redux/actions/billActions';
import { getVendorPurchaseOrder } from '../../redux/actions/purchaseOrderActions';
import { approveBills, rejectBills } from '../../redux/actions/approvalActions';
import PenaltiesActionButton from './penaltiesActionButton';
import PdfActionButton from './pdfActionButton';
import coverLetterPdfActionButton from './coverLetterPdfActionButton';
import billInvoicePdfActionButton from './billInvoicePdfActionButton';


function BillsTable(props) {

  const { billsData, billsLoading, getBills, deleteBill,
    deleteBillIsLoading, getVendorPurchaseOrder, approveBills, rejectBills,
    getFilteredBills, getPenalties, undoApproveBill,
    penaltiesData, penaltiesLoading, billsPagination, getBillPagination } = props;
  
  const [billCurrentPageData, setBillCurrentPageData] = useState(0)
  const [filterValues, setFilterValues] = useState({})

  useEffect(()=>{
    // getFilteredBills(filteredData)
    getBillPagination(1, props.searchValue, filterValues)

  },[props.searchValue, filterValues])

  const handlePaginationChange = (e, { activePage }) => {
      getBillPagination(activePage, props.searchValue, filterValues)

      setBillCurrentPageData(activePage)
  }

  const [selectedRows, setSelectedRows] = useState([]);
  const [activeSelect, setActiveSelect] = useState(false);
  const [grid, setGrid] = useState({});
  const [openApprovalModal, setOpenApprovalModal] = useState(false);
  const [approveButton, setApproveButton] = useState(false);



  const getSelectedRows = (grid) => {

    const selected = grid.api.getSelectedRows()
    setGrid(grid)

    console.log("get Selected Rows", selected)
    setSelectedRows(selected);
    if (selected.length > 0) {
      setActiveSelect(true)
    } else {
      setActiveSelect(false)
    }
  };



  const handleCloseBillApproval = () => {
    setOpenApprovalModal(false)
  };


  const handleOpenApprovalModal = () => {
    setOpenApprovalModal(true)
  };

  const approveBillsSelected = (billDetails) => {
    setApproveButton(true)
    console.log("Submitted Bills", billDetails)

    const approvalData = {
      customerNo: localStorage.getItem('customerNo'),
      userId: localStorage.getItem('userId'),
      billDetails: billDetails
    }

    approveBills(approvalData);
    setApproveButton(false)
  }

  const approveBillsDirectly = () => {

    let billDetails = []
    selectedRows && selectedRows.map((o, i) => {
      let temp = {}
      temp.billReferenceNo = o.refNo
      temp.billNo = o.billNo
      temp.billDate = o.billDate
      temp.billAmount = o.billAmount
      temp.billReceiptDate = o.billReceiptDate
      temp.approvalStatus = "Approved"
      temp.vendorCode = o.vendorCode
      temp.vendorName = o.vendorName
      temp.penaltyList = []
      billDetails[i] = temp
    });

    const approvalData = {
      customerNo: localStorage.getItem('customerNo'),
      userId: localStorage.getItem('userId'),
      billDetails: billDetails
    }


    approveBills(approvalData)

  }


  const rejectBillsSelected = () => {

    let billDetails = [];
    selectedRows && selectedRows.map((o, i) => {
      let temp = {};
      temp.billReferenceNo = o.refNo
      temp.vendorCode = o.vendorCode
      temp.approvalStatus = "Rejected"

      billDetails[i] = temp
    })

    const rejectData = {
      customerNo: localStorage.getItem('customerNo'),
      userId: localStorage.getItem('userId'),
      billDetails: billDetails
    }

    rejectBills(rejectData)
  }

  const unapproveBillsSelected = () => {
    let objectFormation = [];
    let error = false;
    selectedRows.forEach(element => {
      if (element.status == "Pending") {
        cogoToast.warn('Selected Bill has a pending status, please reselect!!!');
        error = true;
        return false;
      } else {
        let temp = {};
        temp.billReferenceNo = element.refNo
        temp.billStatus = 'Pending'
        temp.vendorCode = element.vendorCode
        objectFormation.push(temp);
      }
    });
    if (!error) {
      undoApproveBill(objectFormation)
    }
  }

  const handleSelectAll = () => {
    grid.api.selectAll()
  }

  const handleUnSelectAll = () => {
    grid.api.deselectAll()
  }

  const handleCancel = () => {
    console.log("Grid State", grid)
    grid.api.deselectAll();
    setActiveSelect(false);
  }

  const getFilterDates = (val,startDate, endDate, billStatus,vendorCode, vehicleNo,VehicleId, branchId) => {

    const filteredData = {
      api_token: localStorage.getItem('apiToken'),
      customerNo: localStorage.getItem('customerNo'),
      userId: localStorage.getItem('userId'),
      fromDate: startDate != null  ?  moment(startDate).format(DATE_FORMATS.DD_MM_YYYY) : null,
      toDate: endDate != null  ?  moment(endDate).format(DATE_FORMATS.DD_MM_YYYY) : null,
      billStatus:billStatus ? billStatus : [],
      vendorCode:vendorCode ? vendorCode : '',
      vehicleNo:vehicleNo,
      branchId:branchId
    }

    setFilterValues(filteredData)

    //getFilteredBills(filteredData)
  }

  const refreshDates = () => {
    window.location.reload();
  }
    let columnDefs = [
      {
        headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: (params) => {
          if (params?.data?.status === "Approved") return false;
          else return true;
        }
      },
      {
        headerName: headers.partnerBillNo ||  'Partner Bill No.', field: 'vendorBillNo', cellRenderer: 'paymentModalRenderer',
        tooltipField: EnableIntegratedRefErrorContent ? 'integratedReferenceNumberErrorContent' : 'vendorBillNo',
        enableRowGroup: true, enablePivot: true, filter: true
      },
      { headerName: headers.partnerBillDate || 'Partner Bill Date', field: 'vendorBillDate', tooltipField: 'vendorBillDate', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: '', field: 'billId', hide: true },
      { headerName: headers.referenceNumber || 'Reference No.', field: 'refNo', tooltipField: 'refNo', enableRowGroup: true, enablePivot: true, filter: true },

      { headerName: transworldCustomer ? headers.integratedReferenceNumber || 'Integrated Reference Number' : headers.sapReferenceNumber || 'SAP Reference No.', field: 'integratedReferenceNumber', cellRenderer: 'integratedReferenceNo', enableRowGroup: true, enablePivot: true, filter: true, hide: !EnableIntegratedReferenceNo, },
      { headerName: headers.approvedOn || 'Approved On', field: 'approvedThirdpartyApiDate', tooltipField: 'approvedThirdpartyApiDate', enableRowGroup: true, enablePivot: true, filter: true, hide : !transworldCustomer },

      { headerName: headers.billReciptDate || 'Bill Receipt Date', field: 'billReceiptDate', tooltipField: 'billReceiptDate', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: headers.partnerName || 'Partner Name', field: 'vendorName', tooltipField: 'vendorName', enableRowGroup: true, enablePivot: true, filter: true },
      // { headerName: 'Vendor Group', field: 'vendorGroup', tooltipField: 'vendorGroup', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: headers.billAmount || 'Bill Amount (Rs)', field: 'billAmount', tooltipField: 'billAmount', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: headers.pendingAmount || 'Pending Amount (Rs)', field: 'pendingAmount', tooltipField: 'pendingAmount', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: headers.expectedPaymentDate || 'Expected Payment Date', field: 'expectedPaymentDate', tooltipField: 'expectedPaymentDate', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: headers.penalities || 'Penalties (Rs)', field: 'penalties', cellRenderer: 'penaltiesModalRenderer', width: 160, suppressToolPanel: true },
      { headerName: headers.remarks || 'Remarks', field: 'remarks', tooltipField: 'remarks', width: 160, suppressToolPanel: true },
      { headerName: headers.glCode || 'GL Code', field: 'GLCode', tooltipField: 'GLCode', width: 160, suppressToolPanel: true },
      { headerName: headers.branchName || 'Branch Name', field: 'branchName', tooltipField: 'branchName', width: 160, suppressToolPanel: true },
      {
        headerName: headers.status || 'Status', field: 'status', tooltipField: 'status', enableRowGroup: true, enablePivot: true, filter: true,
        cellStyle: params => {
          if (params.value === 'Completed') {
            return { color: 'green' };
          } else if (params.value === 'Partial Payment') {
            return { color: '#2185d0' };
          }else if(params.value === 'Approved') {
            return { color: 'yellow' };
          } else {
            return { color: 'grey' };
          }
        }
      },
      { headerName: headers.createdOn || 'Created On', field: 'createdOn', tooltipField: 'createdOn', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: headers.createdBy || 'Created By', field: 'createdBy', tooltipField: 'createdBy', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: headers.modifiedOn || 'Modified On', field: 'modifiedOn', tooltipField: 'modifiedOn', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: headers.modifiedBy || 'Modified By', field: 'modifiedBy', tooltipField: 'modifiedBy', enableRowGroup: true, enablePivot: true, filter: true },
      { headerName: headers.invoicePdf || 'Invoice PDF', field: 'pdf', cellRenderer: 'pdfRenderer', suppressToolPanel: true },
      { headerName: headers.coverLetterPdf || 'Cover Letter PDF', field: 'cvPdf', cellRenderer: 'coverLetterRenderer', suppressToolPanel: true },
      { headerName: headers.billInvoicePdf || 'Bill Invoice PDF', field: 'biPdf', cellRenderer: 'billInvoicePdfRenderer', suppressToolPanel: true },
      { headerName: headers.billPdfStatus || 'Bill PDF Status', field: 'billPdfStatus', hide: true, suppressToolPanel: true },
      { headerName: headers.actions || 'View/Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', suppressToolPanel: true, pinned: "right" }
    ]

    let columnKeys = ['vendorBillNo', 'vendorBillDate', 'refNo', 'billReceiptDate', 'vendorName', 'billAmount', 'pendingAmount', 'expectedPaymentDate', 'penalties', 'status', 'createdOn', 'createdBy', 'modifiedOn', 'modifiedBy']

    let frameworkComponents = {
      actionRenderer: BillActionButton,
      paymentModalRenderer: PaymentActionButton,
      integratedReferenceNo: IntegratedReferenceNumber,
      penaltiesModalRenderer: PenaltiesActionButton,
      pdfRenderer: PdfActionButton,
      coverLetterRenderer: coverLetterPdfActionButton,
      billInvoicePdfRenderer: billInvoicePdfActionButton
    }

    let rowData = []

    billsData && billsData.forEach((object, index) => {
      let temp = {}
      temp.vendorBillNo = object.billNo
      temp.vendorBillDate = moment(object.billDate).format(DATE_FORMATS.DD_MM_YYYY || 'DD-MM-YYYY')
      temp.refNo = object.billReferenceNo

      temp.integratedReferenceNumber = object.integratedReferenceNumber
      temp.integratedReferenceNumberErrorContent = object.integratedReferenceNumberErrorContent

      temp.vendorId = object.vendorId
      temp.branchCode = object.branchCode
      temp.branchName = object.branchName
      temp.billReceiptDate = moment(object.billReceiptDate).format(DATE_FORMATS.DD_MM_YYYY || 'DD-MM-YYYY')
      temp.vendorName = object.vendorName
      temp.vendorGroup = ''
      temp.billAmount = object.billAmount
      temp.pendingAmount = object.pendingAmount
      temp.expectedPaymentDate = moment(object.expectedPaymentDate).format(DATE_FORMATS.DD_MM_YYYY || 'DD-MM-YYYY')
      temp.status = object.approvalStatus
      temp.createdOn = object.createdOn
      temp.createdBy = object.createdByName
      temp.modifiedOn = object.updatedOn
      temp.file = object.filePath
      temp.remarks = object.remarks
      temp.coverLetter = object.billCoverLetter
      temp.modifiedBy = object.updatedByName
      temp.totalPenaltyAmt = object.totalPenaltyAmt
      temp.deleteBill = deleteBill
      temp.isLoading = deleteBillIsLoading
      temp.getVendorPurchaseOrder = getVendorPurchaseOrder
      temp.getPenalties = getPenalties
      temp.penaltiesData = penaltiesData
      temp.penaltiesLoading = penaltiesLoading
      temp.billPdfStatus = object.billPdfStatus
      //Extra Data for Edit
      temp.vendorCode = object.vendorCode
      temp.billNo = object.billNo
      temp.billDate = object.billDate
      temp.billPO = object.bill_po_mapping
      temp.billId = object.billId
      temp.GLCode = object.GLCode
      temp.branchName = object.branchName
      temp.approvedThirdpartyApiDate = object.approvedThirdpartyApiDate
      rowData[index] = temp
    })

    const pendingBills = billsData ? billsData.filter(bill => bill.approvalStatus === 'Pending').length : ''
    const approvedBills = billsData ? billsData.filter(bill => bill.approvalStatus === 'Approved').length : ''
    const rejectedBills = billsData ? billsData.filter(bill => bill.approvalStatus === 'Rejected').length : ''
    const partialBills =  billsData ? billsData.filter(bill => bill.approvalStatus === 'Partial Payment').length : ''
    const completed =  billsData ? billsData.filter(bill => bill.approvalStatus === 'Completed').length : ''
    
    const approvalData = {
      pending: pendingBills,
      approved: approvedBills,
      rejected: rejectedBills,
      partialPayment: partialBills,
      completed: completed,
    }


    return (
      <React.Fragment>
        <div style={{ position: 'relative' }}>

          <AgGridTable
            columnDefs={columnDefs}
            rowData={rowData}
            searchValue={props.searchValue}
            link="/add-bill"
            baseURL={props}
            hiddenNewPopupBtn={true}
            hiddenImportPopupBtn={true}
            columnKeys={columnKeys}
            extraComponents={frameworkComponents}
            titleBarTitle="Bills"
            handleSearch={props.handleSearch}
            rowSelected={getSelectedRows}
            approvalCountSection={true}
            approvalData={approvalData}
            isRowSelectable={function (rowNode) {
              return (localStorage.getItem('customerNo') == '1166' || localStorage.getItem('customerNo') == '1165') ? true : rowNode.data && rowNode.data.status !== "Pending" ? false : true;
            }}
            dateFilter={true}
            getFilterDates={getFilterDates}
            refreshDates={refreshDates}
            suppressRowSelection={true}
            bills={true}
            billsData={billsData}
            dataLoading={billsLoading}
            pagination={false}
          />
          <Pagination
            key={
              billsPagination?.currentPage || 1
            }
            defaultActivePage={
              billsPagination?.currentPage || 1
            }
            firstItem={null}
            lastItem={null}
            onPageChange={handlePaginationChange}
            pointing
            secondary
            totalPages={
              billsPagination?.totalPages ?
                billsPagination?.totalPages : 0
            }
        />

          {activeSelect ?

            <Segment
              style={{ position: 'absolute', bottom: 12, left: 0 }}
            >

              <span style={{ color: 'grey', fontSize: '14px' }}>{`Selected (${selectedRows.length}/${billsData.length}) `}</span>
              {selectedRows.length === billsData.length ?
                <Button onClick={handleUnSelectAll} size="mini" color="blue" style={{ marginLeft: '20px', borderRadius: '25px' }}>UnSelect All</Button>
                :
                <Button onClick={handleSelectAll} size="mini" color="blue" style={{ marginLeft: '20px', borderRadius: '25px' }}>Select All</Button>

              }
              <Button onClick={localStorage.getItem('customerNo') === "1158" ? approveBillsDirectly : handleOpenApprovalModal} size="mini" basic color="blue" style={{ marginLeft: '5px', borderRadius: '25px' }}>Approve</Button>
              {(localStorage.getItem('customerNo') == '1166' || localStorage.getItem('customerNo') == '1165') ?
                <Button onClick={unapproveBillsSelected} size="mini" basic color="red" style={{ marginLeft: '5px', borderRadius: '25px' }}>Undo Approve</Button>
                : null}
              <Button onClick={rejectBillsSelected} size="mini" basic color="red" style={{ marginLeft: '5px', borderRadius: '25px' }}>Reject</Button>
              <Button type="button" onClick={handleCancel} size="mini" style={{ marginLeft: '5px', borderRadius: '25px' }}>Cancel</Button>
              {console.log("Selected Rows", selectedRows)}
              <EditModal size="large" open={openApprovalModal} onClose={handleCloseBillApproval}>
                <Modal.Header>Approval</Modal.Header>
                <BillApprovalModal
                  selectedRows={selectedRows}
                  handleCloseBillApproval={handleCloseBillApproval}
                  approveBillsSelected={approveBillsSelected}
                  approveButtonLoading={approveButton}
                />
              </EditModal>
            </Segment>

            :

            ""
          }
        </div>
      </React.Fragment>
    )
  }


const mapStatetoProps = (state) => ({
  billsData: state.getBillsData.bills.data,
  billsLoading: state.getBillsData.isLoading,
  deleteBillIsLoading: state.deleteBillData.isLoading,
  penaltiesData: state.getPenaltiesData.billPenalties.data,
  penaltiesLoading: state.getPenaltiesData.isLoading,
  billsPagination: state.getBillsData.billsPagination,
})

export default connect(mapStatetoProps, { getBills, deleteBill, getVendorPurchaseOrder, approveBills, rejectBills, getFilteredBills, getPenalties, undoApproveBill, getBillPagination })(BillsTable)